const muñequeras = [

{
  id: "muñ-sbd-classic",
  slug: "muñequeras-sbd-classic",
  name: "Muñequeras SBD Classic",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-nue.webp","/Productos/muñ-sbd-nue-2.webp"],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  bestSeller: true,
  variants: [
    { type: "Flexibles", length: 40, price: 102.5 },
    { type: "Flexibles", length: 60, price: 102.5 },
    { type: "Flexibles", length: 100, price: 102.5 },
    { type: "Rígidas", length: 40, price: 102.5 },
    { type: "Rígidas", length: 60, price: 102.5 },
    { type: "Rígidas", length: 100, price: 102.5 },
  ]
},

{
  id: "muñ-sbd-2014",
  slug: "muñequeras-sbd-2014",
  name: "Muñequeras SBD 2014",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd.jpg","/Productos/muñ-sbd-2014-2.webp"],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 95 },
    { type: "Flexibles", length: 60, price: 95 },
    { type: "Flexibles", length: 100, price: 95 },
    { type: "Rígidas", length: 40, price: 95 },
    { type: "Rígidas", length: 60, price: 95 },
    { type: "Rígidas", length: 100, price: 95 },
  ]
},
{
  id: "muñ-sbd-serenity",
  slug: "muñequeras-sbd-serenity",
  name: "Muñequeras SBD Serenity",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-ser.webp", "/Productos/muñ-sbd-ser-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},
{
  id: "muñ-sbd-resolve",
  slug: "muñequeras-sbd-resolve",
  name: "Muñequeras SBD Resolve",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-res.jpg","/Productos/muñ-sbd-res-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

{
  id: "muñ-sbd-aspire",
  slug: "muñequeras-sbd-aspire",
  name: "Muñequeras SBD Aspire",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-asp.jpg","/Productos/muñ-sbd-asp-2.jpg",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

{
  id: "muñ-sbd-reflect",
  slug: "muñequeras-sbd-reflect",
  name: "Muñequeras SBD Reflect",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-ref.webp","/Productos/muñ-sbd-ref-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

{
  id: "muñ-sbd-forge-grey",
  slug: "muñequeras-sbd-forge-grey",
  name: "Muñequeras SBD Forge Grey",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-for-grey.jpg","/Productos/muñ-sbd-for-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

{
  id: "muñ-sbd-forge-orange",
  slug: "muñequeras-sbd-forge-orange",
  name: "Muñequeras SBD Forge Orange",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-for-nar.webp","/Productos/muñ-sbd-for-ora-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},
{
  id: "muñ-sbd-nova",
  slug: "muñequeras-sbd-nova",
  name: "Muñequeras SBD Nova",
  category: "muñequeras",
  brand: "SBD",
  images: ["/Productos/muñ-sbd-nova.webp","/Productos/muñ-sbd-nov-2.webp",],
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},


{
  id: "muñ-sbd-defy",
  category: "muñequeras",
  slug: "muñequeras-sbd-defy",
  name: "Muñequeras SBD Defy",
  brand: "SBD",
  image: "/Productos/sbd-muñ-defy.webp",
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

{
  id: "muñ-sbd-storm",
  category: "muñequeras",
  slug: "muñequeras-sbd-storm",
  name: "Muñequeras SBD Storm",
  brand: "SBD",
  image: "/Productos/sbd-muñ-st.webp",
  types: ["Flexibles", "Rígidas"],
  lengths: [40, 60, 100],
  variants: [
    { type: "Flexibles", length: 40, price: 107.5 },
    { type: "Flexibles", length: 60, price: 107.5 },
    { type: "Flexibles", length: 100, price: 107.5 },
    { type: "Rígidas", length: 40, price: 107.5 },
    { type: "Rígidas", length: 60, price: 107.5 },
    { type: "Rígidas", length: 100, price: 107.5 },
  ]
},

// ================= A7 =================
{
  id: "muñ-a7-stealth",
  slug: "muñequeras-a7-stealth",
  name: "Muñequeras A7 Stealth",
  category: "muñequeras",
  brand: "A7",
  rating: 5,
  image: "/Productos/muñ-a7-black.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90 },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90 },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90  },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-shadow-stone",
  slug: "muñequeras-a7-shadow-stone",
  name: "Muñequeras A7 Shadow Stone",
  category: "muñequeras",
  brand: "A7",
  rating: 5,
  image: "/Productos/muñ-a7-sha.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90 },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-red-dawn",
  category: "muñequeras",
  slug: "muñequeras-a7-red-dawn",
  name: "Muñequeras A7 Red Dawn",
  brand: "A7",
  image: "/Productos/muñ-a7-red.webp",
  types: ["Flexible", "Medium", "Rígida", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90 },
    { type: "Medium", length: 99, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90 },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90 },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-violet",
  slug: "muñequeras-a7-violet",
  name: "Muñequeras A7 Violet",
  category: "muñequeras",
  brand: "A7",
  image: "/Productos/muñ-a7-vio.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90 },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90 },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90  },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-night-light",
  slug: "muñequeras-a7-night-light",
  name: "Muñequeras A7 Night Light",
  category: "muñequeras",
  brand: "A7",
  image: "/Productos/muñ-a7-nl.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90 },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-polar",
  category: "muñequeras",
  slug: "muñequeras-a7-polar",
  name: "Muñequeras A7 Polar",
  brand: "A7",
  rating: 5,
  image: "/Productos/muñ-a7-po.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90 },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90 },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90  },
    { type: "Medium", length: 77, price: 72, oldPrice: 90  },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90 },
    { type: "Rigor Mortis", length: 55,price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77,price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

{
  id: "muñ-a7-ivory-rose",
  slug: "muñequeras-a7-ivory-rose",
  name: "Muñequeras A7 Ivory Rose",
  category: "muñequeras",
  brand: "A7",
  rating: 5,
  image: "/Productos/muñ-a7-ivo.webp",
  types: ["Flexibles", "Medium", "Rígidas", "Rigor Mortis"],
  lengths: [55, 77, 99],
  variants: [
    { type: "Flexibles", length: 55, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 77, price: 72, oldPrice: 90  },
    { type: "Flexibles", length: 99, price: 72, oldPrice: 90  },
    { type: "Medium", length: 55, price: 72, oldPrice: 90 },
    { type: "Medium", length: 77, price: 72, oldPrice: 90 },
    { type: "Medium", length: 99, price: 72, oldPrice: 90  },
    { type: "Rígidas", length: 55, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 77, price: 72, oldPrice: 90 },
    { type: "Rígidas", length: 99, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 55, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 77, price: 72, oldPrice: 90  },
    { type: "Rigor Mortis", length: 99, price: 72, oldPrice: 90  },
  ]
},

  // INZER
{
    id: "muñ-inzer-iron",
    category: "muñequeras",
    slug: "muñequeras-inzer-iron",
    name: "Inzer Iron",
    brand: "INZER",
    image: "/Productos/muñ-inz-iro.jpg",
    lengths: [50, 90],
    variants: [
      { length: 50, price: 75 },
      { length: 90, price: 75 },
    ],
  },
  {
    id: "muñ-inzer-beauty-black",
    category: "muñequeras",
    slug: "muñequeras-inzer-beauty-black",
    name: "Inzer Beauty Black",
    brand: "INZER",
    image: "/Productos/muñ-inz-bb.webp",
    lengths: [50, 90],
    variants: [
      { length: 50, price: 105 },
      { length: 90, price: 105 },
    ],
  },
  {
    id: "muñ-inzer-atomic",
    category: "muñequeras",
    slug: "muñequeras-inzer-atomic",
    name: "Inzer Atomic",
    brand: "INZER",
    image: "/Productos/muñ-inz-ato.jpg",
    lengths: [50, 90],
    variants: [
      { length: 50, price: 95 },
      { length: 90, price: 80 },
    ],
  },

  // PIONEER 
  {
    id: "muñ-pioneer-heavy",
    category: "muñequeras",
    slug: "muñequeras-pioneer-heavy",
    name: "Pioneer Heavy",
    brand: "PIONEER",
    image: "/Productos/muñ-pio-hea.jpg",
    lengths: [45, 60, 90],
    variants: [
      { length: 45, price: 90 },
      { length: 60, price: 90 },
      { length: 90, price: 90 },
    ],
  },
    {
    id: "muñ-pioneer-medium",
    category: "muñequeras",
    slug: "muñequeras-pioneer-medium",
    name: "Pioneer Medium",
    brand: "PIONEER",
    image: "/Productos/muñ-pio-med.jpg",
    lengths: [45, 60, 90],
    variants: [
      { length: 45, price: 85 },
      { length: 60, price: 85 },
      { length: 90, price: 85 },
    ],
  },
      {
    id: "muñ-pioneer-light",
    category: "muñequeras",
    slug: "muñequeras-pioneer-light",
    name: "Pioneer Light",
    brand: "PIONEER",
    image: "/Productos/muñ-pio-lig.jpg",
    lengths: [45, 60, 90],
    variants: [
      { length: 45, price: 80 },
      { length: 60, price: 80 },
      { length: 90, price: 80 },
    ],
  },

  // TITAN (solo longitudes)
  {
    id: "muñ-titan-gold-signature",
    category: "muñequeras",
    slug: "muñequeras-titan-gold-signature",
    name: "Titan Gold Signature",
    brand: "TITAN",
    image: "/Productos/muñ-titan-g.webp",
    lengths: [30, 48, 60, 75, 90],
    variants: [
      { length: 30, price: 80 },
      { length: 48, price: 82.5 },
      { length: 60, price: 87.5 },
      { length: 75, price: 90 },
      { length: 90, price: 95 },
    ],
  },

  // STOIC
  {
    id: "muñ-stoic",
    category: "muñequeras",
    slug: "muñequeras-stoic",
    name: "Muñequeras Stoic",
    brand: "STOIC",
    image: "/Productos/muñ-stoic.webp",
    lengths: [45, 60, 90],
    variants: [
      { length: 45, price: 82.5 },
      { length: 60, price: 82.5 },
      { length: 90, price: 82.5 },
    ],
  },
];

export default muñequeras;
